var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.204 12.326v2.556c2.871.896 4.963 3.495 4.963 6.598v8.229c0 3.842-3.186 6.957-7.113 6.957H12.948c-3.93 0-7.115-3.115-7.115-6.957V21.48c0-3.103 2.093-5.702 4.962-6.598v-2.556c.017-4.968 4.133-8.993 9.18-8.993 5.114 0 9.23 4.025 9.23 8.993Zm-9.196-6.095c3.438 0 6.233 2.733 6.233 6.095v2.197H13.759v-2.23c.017-3.345 2.811-6.062 6.25-6.062Zm1.474 21.194c0 .811-.66 1.457-1.49 1.457a1.462 1.462 0 0 1-1.474-1.457v-3.677c0-.795.66-1.441 1.473-1.441.83 0 1.49.646 1.49 1.44v3.678Z"
  })));
};
export default SvgLock;